module.exports = __webpack_public_path__ + "img/shili.70f2ca70.png";